export default __webpack_public_path__ + "static/media/you-can-do-it-480w.6ee56a58.png";